import script from "./page.vue?vue&type=script&setup=true&lang=js"
export * from "./page.vue?vue&type=script&setup=true&lang=js"

import "./page.vue?vue&type=style&index=0&id=0b53ddee&scoped=true&lang=scss"

import exportComponent from "/Users/windy/work/vue/zhibo_am/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b53ddee"]])

export default __exports__